import { render, staticRenderFns } from "./dataView.vue?vue&type=template&id=7fd80a28&scoped=true"
import script from "./dataView.vue?vue&type=script&lang=js"
export * from "./dataView.vue?vue&type=script&lang=js"
import style0 from "./dataView.vue?vue&type=style&index=0&id=7fd80a28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd80a28",
  null
  
)

export default component.exports